<!-- MAIA Step 3 of 4 — Portfolio enrichment (paid overlay selection). Design phase. -->
<div class="maia-enrich-step" data-testid="maia-enrich-step">


    <header class="step-header">
        <div class="step-heading">
            <h1>Portfolio enrichment</h1>
            <p>
                Add premium datasets to enrich your portfolio.<br>
                Your locations will be automatically enriched with authoritative datasets, including FEMA, NOAA, GEM, and more.
            </p>
        </div>
    </header>

    <section class="enrich-panel">
        <p class="enrich-empty" *ngIf="loading">Loading available datasets…</p>
        <p class="enrich-empty" *ngIf="!loading && datasets.length === 0">
            No paid datasets are assigned to this account. Your portfolio will still be enriched with the free datasets.
        </p>
        <ul class="enrich-grid" *ngIf="datasets.length">
            <li class="enrich-card" *ngFor="let d of datasets" [class.selected]="d.selected" (click)="toggle(d)">
                <div class="enrich-card-head">
                    <span class="enrich-icon" [style.background]="d.iconColor" aria-hidden="true">
                        <svg *ngIf="d.icon === 'shield'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 3l7 3v5c0 4.5-3 7.2-7 8.4C8 18.2 5 15.5 5 11V6z"></path>
                        </svg>
                        <svg *ngIf="d.icon === 'building'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="5" y="3" width="9" height="18" rx="1"></rect>
                            <path d="M14 9h5v12"></path>
                            <line x1="8" y1="7" x2="11" y2="7"></line>
                            <line x1="8" y1="11" x2="11" y2="11"></line>
                            <line x1="8" y1="15" x2="11" y2="15"></line>
                        </svg>
                        <svg *ngIf="d.icon === 'flame'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 3s5 4 5 9a5 5 0 0 1-10 0c0-2 1-3.5 2-4.5.2 1.3 1 2.5 2 2.5 0-3 1-5 1-7z"></path>
                        </svg>
                    </span>
                    <span class="enrich-name">{{ d.name }}</span>
                    <input type="checkbox" class="enrich-check" [checked]="d.selected"
                           (click)="$event.stopPropagation()" (change)="toggle(d)"
                           [attr.aria-label]="'Add ' + d.name" />
                </div>

                <p class="enrich-desc">{{ d.description }}</p>

                <span class="enrich-scope">
                    <span class="scope-chip">
                        <svg *ngIf="d.scopeType === 'global'" width="13" height="13" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="9"></circle>
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18"></path>
                        </svg>
                        <svg *ngIf="d.scopeType === 'country' && d.scope === 'USA'" width="16" height="12"
                             viewBox="0 0 26 18" class="flag-usa" aria-label="USA">
                            <rect width="26" height="18" fill="#fff"></rect>
                            <g fill="#b22234">
                                <rect y="0" width="26" height="1.4"></rect>
                                <rect y="2.8" width="26" height="1.4"></rect>
                                <rect y="5.6" width="26" height="1.4"></rect>
                                <rect y="8.3" width="26" height="1.4"></rect>
                                <rect y="11.1" width="26" height="1.4"></rect>
                                <rect y="13.8" width="26" height="1.4"></rect>
                                <rect y="16.6" width="26" height="1.4"></rect>
                            </g>
                            <rect width="11" height="9.7" fill="#3c3b6e"></rect>
                            <g fill="#fff">
                                <circle cx="2" cy="1.8" r="0.7"></circle>
                                <circle cx="5.5" cy="1.8" r="0.7"></circle>
                                <circle cx="9" cy="1.8" r="0.7"></circle>
                                <circle cx="3.7" cy="3.8" r="0.7"></circle>
                                <circle cx="7.2" cy="3.8" r="0.7"></circle>
                                <circle cx="2" cy="5.8" r="0.7"></circle>
                                <circle cx="5.5" cy="5.8" r="0.7"></circle>
                                <circle cx="9" cy="5.8" r="0.7"></circle>
                                <circle cx="3.7" cy="7.8" r="0.7"></circle>
                                <circle cx="7.2" cy="7.8" r="0.7"></circle>
                            </g>
                        </svg>
                        <svg *ngIf="d.scopeType === 'country' && d.scope !== 'USA'" width="13" height="13" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="5" y1="21" x2="5" y2="4"></line>
                            <path d="M5 4h13l-2.5 4L18 12H5"></path>
                        </svg>
                        <span>{{ d.scope }}</span>
                    </span>
                    <span class="credits-apply">Credits apply</span>
                </span>
            </li>
        </ul>
    </section>

    <footer class="step-footer">
        <!-- <button type="button" class="btn btn-secondary" (click)="backRequested.emit()">Back</button> -->
        <button type="button" class="btn btn-primary" (click)="startEnrichment()">Start Enrichment</button>
    </footer>

    <!-- Confirmation popup -->
    <div class="confirm-scrim" *ngIf="showConfirm" (click)="cancelConfirm()">
        <div class="confirm-dialog" (click)="$event.stopPropagation()" role="dialog" aria-modal="true"
             aria-labelledby="confirm-title">
            <div class="confirm-head">
                <h2 id="confirm-title" class="confirm-title">Add Premium Datasets?</h2>
                <button type="button" class="confirm-close" aria-label="Close" (click)="cancelConfirm()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="9"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                </button>
            </div>
            <p class="confirm-body">
                This will add data to your portfolio. Your account will be charged based on your current plan.
            </p>
            <div class="confirm-actions">
                <button type="button" class="btn btn-secondary" [disabled]="submitting"
                        (click)="cancelConfirm()">Cancel</button>
                <button type="button" class="btn btn-primary" [disabled]="submitting" (click)="confirmAdd()">
                    {{ submitting ? 'Adding…' : 'Add & Continue' }}
                </button>
            </div>
        </div>
    </div>
</div>
